export default __webpack_public_path__ + "static/media/discounts-12off40-image.a41c6aed.svg";